import React from 'react';
import { useNavigate } from 'react-router-dom';
import HighRiskFreeBackground from "../../assets/home/Black.png"
import RiskFreeIcon1 from "../../assets/home/risk-free-icon1.png"
import RiskFreeIcon2 from "../../assets/home/risk-free-icon2.png"
import RiskFreeIcon3 from "../../assets/home/risk-free-icon3.png"
import RiskFreeIcon4 from "../../assets/home/risk-free-icon4.png"
import Image from '../../components/general/Image';
import Button from '../../components/general/Button';
import StarOrange from "../../assets/home/StarOrange.svg"
import StarWhite from "../../assets/home/StartWhite.svg"

const HighRiskFree = () => {
  const backgroundImage = {
    backgroundImage: `url(${HighRiskFreeBackground})`,
    backgroundSize: 'cover',
    backgroundColor: 'black',
    color: 'black',
    position: 'relative',
    zIndex: '0',
  }

  return (
    <section className="" style={backgroundImage}>
      <div className="text-white --layout-padding -mt-[40px] !pt-[100px] md:!pt-[150px] !pb-[50px] lg:!pt-[100px] max-width">
        <div className="highRiskCon">
          <div className="highRiskText">
            <h3 className="text-[30px] lg:text-55 text-center font-semibold mb-[20px]">
              Scalable IT teams that evolve with 
              <div className='hidden lg:inline-flex lg:-translate-y-[20px]'>
                <Image src={StarOrange} alt="" className='w-[50px]'/>
                <Image src={StarWhite} alt="" className='w-[20px] h-[20px]'/>
              </div>
              <span className='text-primary-color lg:block'> your roadmap </span>
            </h3>
            <p className="text-[#D7D7D7] text-center">Devhire partners with you on a month-to-month basis — no long-term contracts, no wasted spend. <br className='hidden lg:block' /> Scale your team as needed, when needed.</p>
          </div>
          <div className="mt-[20px] lg:mt-[50px]">
            <ul className='flex flex-col md:grid md:grid-cols-2 gap-[30px] lg:grid-cols-4 justify-center'>
              <li className=''>
                <figure className='mb-[10px]'><Image src={RiskFreeIcon1} className='mx-auto lg:mx-0' alt=""/></figure>
                <h4 className='text-[20px] font-semibold text-center lg:text-left'>Scale When <br />Ready </h4>
                <p className='text-[14px] text-center lg:text-left mt-[10px]'>Need one developer or five? Scale your team up or down in days — no bureaucracy, no long-term ties.</p>
              </li>
              <li className='lg:border-l lg:border-[#787878] lg:pl-[30px]'>
                <figure className='mb-[10px]'><Image src={RiskFreeIcon2} className='mx-auto lg:mx-0' alt=""/></figure>
                <h4 className='text-[20px] font-semibold text-center lg:text-left'>Adapt with <br />Ease </h4>
                <p className='text-[14px] text-center lg:text-left mt-[10px]'>Shift directions mid-sprint? Need a new skillset? We make adjustments easy — with flexible talent on standby.</p>
              </li>
              <li className='lg:border-l lg:border-[#787878] lg:pl-[30px]'>
                <figure className='mb-[10px]'><Image src={RiskFreeIcon3} className='mx-auto lg:mx-0' alt=""/></figure>
                <h4 className='text-[20px] font-semibold text-center lg:text-left'>No Strings <br />Attached </h4>
                <p className='text-[14px] text-center lg:text-left mt-[10px]'>Work with us as long as it works for you. Pause, switch, or cancel — no penalties, no stress.</p>
              </li>
              <li className='lg:border-l lg:border-[#787878] lg:pl-[30px]'>
                <figure className='mb-[10px]'><Image src={RiskFreeIcon4} className='mx-auto lg:mx-0' alt=""/></figure>
                <h4 className='text-[20px] font-semibold text-center lg:text-left'>Your Hours, <br /> Always </h4>
                <p className='text-[14px] text-center lg:text-left mt-[10px]'>Developers work in your time zone and sync with your preferred hours — easily adjustable as your needs evolve.</p>
              </li>
            </ul>
          </div>
          <div className="text-center my-[20px] md:my-[50px] md:mb-0">
            <Button className='bg-primary-color text-black w-[200px] h-[50px] mx-auto rounded text-[0.8rem]'>Hire risk-free <i className="fa-solid fa-arrow-up-right" /></Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighRiskFree;